import React, { useState, useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Footer from '../Footer/Main';
import Navbar from '../Navbar/Main';
import { Pagination } from '../DataTable';
import BGPH1 from '../../assets/images/backgrounds/page-header-bg-1-1.jpg';

const Faqs = () => {
    const [clicked, setClicked] = useState(null);
    const [doc, setFaqs] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedCategory, setSelectedCategory] = useState('Insurance');
    const ITEMS_PER_PAGE = 10;

    useEffect(() => {
        axios.get(`/faqs`)
            .then((response) => {
                setFaqs(response.data);
            })
            .catch((error) => console.log(error));
    }, []);

    const categories = ['Insurance', 'Forex', 'Other'];

    // Filter FAQs based on selected category
    const filteredFaqs = useMemo(() => {
        return doc.filter(faq => {
            const category = faq.category || 'Other';
            return category === selectedCategory;
        });
    }, [doc, selectedCategory]);

    const paginatedFaqs = useMemo(() => {
        return filteredFaqs.slice(
            (currentPage - 1) * ITEMS_PER_PAGE,
            (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
        );
    }, [filteredFaqs, currentPage]);

    // Category metadata with icons
const categoryMeta = [
    { key: 'Insurance', label: 'Insurance', icon: '🛡' },
    { key: 'Forex', label: 'Forex', icon: '💱' },
    { key: 'Other', label: 'Other', icon: '📄' }
];

// Count FAQs per category
const faqCounts = useMemo(() => {
    const counts = { Insurance: 0, Forex: 0, Other: 0 };
    doc.forEach(faq => {
        const cat = faq.category || 'Other';
        if (counts[cat] !== undefined) {
            counts[cat]++;
        } else {
            counts.Other++;
        }
    });
    return counts;
}, [doc]);

    const handleTabClick = (category) => {
        setSelectedCategory(category);
        setCurrentPage(1); // Reset pagination when switching tab
        setClicked(null);  // Close any open accordion
    };

    return (
        <>
            <Navbar />
            <div className="stricky-header stricked-menu main-menu">
                <div className="sticky-header__content"></div>
            </div>

            <section className="page-header">
                <div
                    className="page-header__bg"
                    style={{ backgroundImage: `url(${BGPH1})` }}
                ></div>
                <div className="container">
                    <ul className="thm-breadcrumb list-unstyled">
                        <li><Link to="/">Home</Link></li>
                        <li><span>Frequently Asked Questions</span></li>
                    </ul>
                </div>
            </section>

            <section className="service-four pt-50 pb-50">
                <div className="container">
                    <div className="row service-four__inner"> 
                    {/* Category Tabs */}
                   <div className="faq-tabs mb-4 text-center">
                        {categoryMeta.map(({ key, label, icon }) => (
                            <button
                                key={key}
                                onClick={() => handleTabClick(key)}
                                className={`faq-tab-button ${selectedCategory === key ? 'active' : ''}`}
                            >
                                <span className="me-2">{icon}</span>
                                {label}
                                <span className="faq-count"> ({faqCounts[key] || 0})</span>
                            </button>
                        ))}
                    </div>

                    {/* FAQ Accordions for Selected Category */}
                    {paginatedFaqs.length === 0 ? (
                        <p className="text-center">No FAQs found in this category.</p>
                    ) : (
                        paginatedFaqs.map((item, index) => (
                            <div
                                key={item.id || index}
                                className={`accrodion-grp service-details__accrodion mb-3 ${clicked === item.id ? "active" : ""}`}
                                data-grp-name="service-details__accrodion-1"
                            >
                                <div className="accrodion wow fadeInUp" data-wow-delay="0ms">
                                    <div
                                        className="accrodion-title"
                                        onClick={() => setClicked(clicked === item.id ? null : item.id)}
                                    >
                                        <h4>{item.question}</h4>
                                        <span className="accrodion-icon"></span>
                                    </div>
                                    {clicked === item.id && (
                                        <div className="accrodion-content">
                                            <div className="inner_doc">
                                                <p>{item.answer}</p>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))
                    )}

                    <div className="d-flex justify-content-center mt-4">
                        <Pagination
                            total={filteredFaqs.length}
                            itemsPerPage={ITEMS_PER_PAGE}
                            currentPage={currentPage}
                            onPageChange={page => setCurrentPage(page)}
                        />
                    </div>
                </div>
                
                    </div>
            </section>

            <Link to="#" data-target="html" className="scroll-to-target scroll-to-top">
                <i className="fa fa-angle-up"></i>
            </Link>
            <Footer />
        </>
    );
};

export default Faqs;
